@import (reference) '~style-sheet-helpers/core.less';
@import (reference) '../../../../../constants/spacing.module.less';

.option-label {
  white-space: nowrap;
}

.uom-pill {
  display: inline-block;
  padding: 2px @space-8;
  background-color: var(--orange-FFF3E0);
  color: var(--orange-E65100);
  border-radius: @space-4;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}
